
"use client";

import React from 'react';
import { useAuth } from './AuthContext';
import { Loader2 } from 'lucide-react';

const FullScreenLoader = () => (
  <div className="fixed inset-0 bg-white z-50 flex items-center justify-center">
    <Loader2 className="animate-spin text-amber-500" size={48} />
  </div>
);

export const SessionProvider = ({ children }: { children: React.ReactNode }) => {
  const { isLoading } = useAuth();
  if (isLoading) {
    return <FullScreenLoader />;
  }
  return <>{children}</>;
};